<template>
   <div class="container flex w-full flex-row flex-wrap gap-8">
      <template v-for="(card, i) in props.cards" :key="`card-${i}`">
         <component
            :is="cardComponents[card.type]"
            v-bind="card"
            class="min-h-[35rem] w-full overflow-hidden rounded-xl md:max-w-[45rem] md:max-lg:min-h-[31rem] lg:max-w-[27rem] lg:max-xl:min-h-[36rem] xl:min-h-[40rem] xl:max-w-[36rem]"
         ></component>
      </template>
   </div>
</template>

<script setup lang="ts">
import BaseCard from "@/components/cards/BaseCard.vue";
import LabelValueListCard from "@/components/cards/LabelValueListCard.vue";
import DualCard from "@/components/cards/DualCard.vue";
import ArticleCard from "@/components/cards/ArticleCard.vue";
import ImageCard from "@/components/cards/ImageCard.vue";

const cardComponents = {
   card_base: BaseCard,
   card_label_value_list: LabelValueListCard,
   card_dual: DualCard,
   card_article: ArticleCard,
   card_image: ImageCard,
};

const props = defineProps<{
   cards: any;
}>();
</script>
<style scoped lang="scss"></style>
